import { render, staticRenderFns } from "./Sorts.vue?vue&type=template&id=752369f6&scoped=true"
import script from "./Sorts.vue?vue&type=script&lang=js"
export * from "./Sorts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752369f6",
  null
  
)

export default component.exports